import FormFooter from 'components/organisms/Form/FormFooter/FormFooter'
import { Form, Formik } from 'formik'
import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'
import { FaEdit, FaTrashAlt } from 'react-icons/fa'
import { connect } from 'react-redux'
import { NavLink } from 'react-router-dom'
import CountryService from 'services/CountryService'
import * as Yup from 'yup'
import * as FormConst from '../../../../constants/FormConst'
import RouteConst from '../../../../constants/RouteConst'
import SessionConst from '../../../../constants/SessionConst'
import SideNavEntryMapping from '../../../../constants/SideNavEntryMapping'
import { asyncMethod } from '../../../../redux/actions'
import * as actionTypes from '../../../../redux/actionTypes'
import DestinationsService from '../../../../services/DestinationsService'
import {isArrayNotEmpty, isObjectEmpty, scrollToHtmlElementById, searchFirstObjectInList, searchObjectList, searchObjectListBoolean, sortObjectList, isCompletedHotelInfoHistory} from '../../../../utilities/JSUtil'
import { getSessionItem } from '../../../../utilities/SessionHelper'
import Button from '../../../atoms/Button/Button'
import SelectInput from '../../../atoms/form/SelectInput/SelectInput'
import TextInput from '../../../atoms/form/TextInput/TextInput'
import ToggleSwitch from '../../../atoms/form/ToggleSwitch/ToggleSwitch'
import FormModal from '../../../organisms/FormModal/FormModal'
import withFormLayout from '../WithFormLayout'
import './Airports.scss'


class Airports extends Component {

    constructor(props) {
        super(props)
        const hotelCode = getSessionItem(SessionConst.HOTEL_CODE)
        const hotelInfo = getSessionItem(SessionConst.HOTEL_INFO)
        const countryCode = hotelInfo?.address?.country
        const hotelInfoCompletedHistory = getSessionItem(SessionConst.HOTEL_INFO_COMPLETED_HISTORY)

        if (!hotelCode || !hotelInfo || !countryCode) {
            this.props.history.replace(RouteConst.ROUTE_HOME_PAGE)
        }

        const hotelBrandCode = hotelInfo.brandCode;
        let availableHotelContent = FormConst.HOTEL_CONTENT_DEFAULT_SECTIONS[hotelBrandCode];
        let returnDirection = RouteConst.ROUTE_BUSINESSES_PAGE;
        let returnTitle = 'Businesses';
        if (availableHotelContent !== undefined && availableHotelContent.includes('S')) {
            returnDirection = RouteConst.ROUTE_SPA_PAGE;
            returnTitle = 'On-Site Spa';
        }

        this.state = {
            hotelCode: hotelCode,
            hotelInfo: hotelInfo,
            countryCode: countryCode,
            continueFlow: this.props.history.location?.state?.continueFlow,
            distanceUnits: getSessionItem(SessionConst.DISTANCE_UNIT_LABEL),
            airports: [],
            otherDestinationEntries: {},
            isEdit: false,
            editIndex: -1,
            showNewAirportFields: false,
            deleteIndex: -1,
            showDeleteModal: false,
            initialValues: { ...this.initialValues },
            isLoading: true,
            loadingMessage: FormConst.MODAL_READ_ACTION_TEXT,
            hotelInfoCompletedHistory: hotelInfoCompletedHistory,
            returnDirection: returnDirection,
            returnTitle: returnTitle
        }
    }

    initialValues = {
        country: '', state: '', airportCode: '',
        airportName: '', distance: '', distanceUnits: '',
        isShuttle: false, isShuttleFree: false, startTime: '', endTime: '',
        airportOptions: [],
        stateOptions: []
    }

    validationSchema = Yup.object().shape({
        country: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
        airportCode: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
        distance: Yup.number().typeError('Should be a number')
            .required(FormConst.VALIDATION_ERROR_REQUIRED)
            .min(0, FormConst.VALIDATION_ERROR_NUMBER_GREATER_THAN_OR_EQUAL_TO_ZERO)
            .max(FormConst.MAX_DESTINATION_DISTANCE, FormConst.VALIDATION_ERROR_DESTINATIONS_DISTANCE),
        direction: Yup.string().required(FormConst.VALIDATION_ERROR_REQUIRED),
        isShuttleFree: Yup.string().when('isShuttle', {
            is: true,
            then: Yup.string.apply().required(FormConst.VALIDATION_ERROR_REQUIRED)
        }),
        startTime: Yup.string().when('isShuttle', {
            is: true,
            then: Yup.string.apply().required(FormConst.VALIDATION_ERROR_REQUIRED)
        }),
        endTime: Yup.string().when('isShuttle', {
            is: true,
            then: Yup.string.apply().required(FormConst.VALIDATION_ERROR_REQUIRED)
        })
    })

    async componentDidMount() {
        if (isCompletedHotelInfoHistory(this.state.hotelInfoCompletedHistory)) {
            let hotelDestinations = this.state.hotelInfoCompletedHistory.newEntity?.hotelDestinations?.hotelDestinations;

            if (hotelDestinations) {
                await this.buildFormValues(hotelDestinations);
            } else {
                this.setState({error: 'Could not retrieve details', isLoading: false})
            }
        } else {
            await DestinationsService.getHotelDestinations({ hotelCode: this.state.hotelCode })
                .then(async response => {
                    let hotelDestinations = response?.hotelDestinations;
                    if (hotelDestinations) {
                        await this.buildFormValues(hotelDestinations);
                    }
                }).catch(error => {
                    this.setState({ error: 'Could not retrieve details', isLoading: false })
                });
        }
    }

    async buildFormValues(hotelDestinations) {
        let existingAirports = []
        let otherDestinationEntries = {}
        await CountryService.getCountries({
            hotelCode: this.state.hotelCode,
            locationType: 'airport',
        }).then(countryServiceResponse => {
            let countryOptions = countryServiceResponse.countries.map(country => {
                return {
                    label: country.name,
                    value: country.iso2Code
                }
            })

            countryOptions = sortObjectList(countryOptions, 'label')

            const airports = hotelDestinations.airport
            otherDestinationEntries = !isObjectEmpty(hotelDestinations) ? {
                    ...hotelDestinations,
                    airport: undefined
                }
                :
                { airport: undefined }
            if (airports) {
                existingAirports = airports && airports.length > 0 ? [...airports] : []
            }
            this.setState({
                airports: existingAirports,
                otherDestinationEntries: otherDestinationEntries,
                isLoading: false,
                countryOptions: countryOptions
            })
        }).catch(error => {
            this.setState({ error: 'Could not retrieve country details', isLoading: false })
        })
    }

    handleSubmit = (formData) => {
        let airports = this.state.airports.length > 0 ? [...this.state.airports] : []
        const newEntry = {
            destinationType: FormConst.DESTINATION_TYPE_AIRPORT,
            code: formData.airportCode,
            name: formData.airportName,
            address: {
                state: formData.state
                    ? searchFirstObjectInList('value', formData.airportCode, formData.airportOptions)?.state
                    : undefined,
                country: formData.country
            },
            proximity: {
                distanceValue: formData.distance,
                distanceUnit: this.state.distanceUnits,
                direction: formData.direction
            },
            transportationMode: {
                transportationCode: formData.isShuttleFree ? 'CCAR' : 'SHTL',
                shuttleAvailable: formData.isShuttle,
                feeRequired: !formData.isShuttleFree,
                operatingHours: formData.startTime && formData.endTime
                    ? {
                        open: formData.startTime,
                        close: formData.endTime
                    }
                    : undefined
            }
        }

        if (this.state.isEdit) {
            // Edit existing entry
            airports[this.state.editIndex] = newEntry
        } else {
            airports.push(newEntry)
        }

        let newDestinationEntries
        if (this.state.otherDestinationEntries) {
            newDestinationEntries = {
                ...this.state.otherDestinationEntries,
                airport: [...airports]
            }
        } else {
            newDestinationEntries = {
                airport: [...airports]
            }
        }

        this.props.onPut({ hotelCode: this.state.hotelCode, formData: newDestinationEntries })

        this.setState({
            pendingAirports: [...airports],
            newPendingAirport: { ...formData },
            isLoading: true,
            loadingMessage: FormConst.MODAL_UPDATE_ACTION_TEXT
        })
    }

    handleReset = () => {
    }

    handleDelete = (index) => {
        this.setState({ showDeleteModal: true, deleteIndex: index })
    }

    handleClearForm = () => {
        this.setState({ showResetModal: true })
    }

    discardNewFields = (formikResetForm) => {
        formikResetForm({ ...this.initialValues })
        // Scroll the table into view after discarding
        scrollToHtmlElementById('airports-table')
        this.setState({
            initialValues: { ...this.initialValues },
            isEdit: false,
            editIndex: -1,
            showNewAirportFields: false,
            showResetModal: false
        })
    }

    handleProceed = () => {
        // Continue to next form
        if (this.state.continueFlow) {
            // Go to the next page
            this.props.history.push({
                pathname: RouteConst.ROUTE_RESTAURANTS_PAGE,
                state: {
                    continueFlow: this.state.continueFlow
                }
            })
        } else {
            // Go back to Destinations page
            this.props.history.push(RouteConst.ROUTE_DESTINATIONS_PAGE)
        }
    }

    onEdit = async (index) => {
        const entryToEdit = this.state.airports[index]
        
        await CountryService.getCountries({
            hotelCode: this.state.hotelCode,
            locationType: 'airport',
            queryParams: { countryCode: entryToEdit.address.country, expand: 'subdivisions' }
        }).then(async countryServiceResponse => {

            const country = countryServiceResponse.countries[0]
            const states = country.subdivisions

            const stateOptions = states.map(state => {
                return {
                    label: state.name,
                    value: state.isoCode.split('-')[1],
                    commonAbbreviation: state.commonAbbreviation
                }
            })

            await DestinationsService.getIataLocations({ hotelCode: this.state.hotelCode, queryParams: { countryCode: entryToEdit.address.country } })
                .then(airportsResponse => {
                    const iataLocations = airportsResponse.iataLocation
                    const airportIataLocations = searchObjectList('iataLocationKind', 'AIRPORT', iataLocations)

                    const airportOptions = airportIataLocations.map(airport => {
                        return {
                            label: airport.iataLocationCode + ' (' + airport.city + ')',
                            value: airport.iataLocationCode,
                            state: airport.stateOrProvince,
                            name: airport.city
                        }
                    })

                    this.setState({
                        isEdit: true,
                        editIndex: index,
                        initialValues: {
                            country: entryToEdit.address.country || '',
                            state: entryToEdit.address.state
                                ? searchObjectListBoolean('value', entryToEdit.address.state, stateOptions) ? entryToEdit.address.state : FormConst.VALUE_ALL_STATES
                                : FormConst.VALUE_ALL_STATES,
                            airportCode: entryToEdit.code || '',
                            airportName: entryToEdit.name || '',
                            distance: entryToEdit.proximity ? entryToEdit.proximity.distanceValue : '', distanceUnits: this.state.distanceUnits,
                            direction: entryToEdit.proximity ? entryToEdit.proximity.direction : '',
                            isShuttle: entryToEdit.transportationMode ? entryToEdit.transportationMode.shuttleAvailable === true : false, isShuttleFree: entryToEdit.transportationMode ? !entryToEdit.transportationMode.feeRequired : false,
                            startTime: entryToEdit.transportationMode?.operatingHours?.open || '', endTime: entryToEdit.transportationMode?.operatingHours?.close || '',
                            airportOptions: airportOptions,
                            stateOptions: stateOptions,
                        },
                        showNewAirportFields: true,
                        isLoading: false,
                    })
                }).catch(error => {
                    this.setState({
                        errorMessage: 'Could not get airport information',
                        showErrorModal: true
                    })
                })
        }).catch(error => {
            this.setState({
                errorMessage: 'Could not get country information',
                showErrorModal: true
            })
        })
    }

    onDelete = () => {
        let index = this.state.deleteIndex
        let airports = [...this.state.airports]
        airports.splice(index, 1)

        let newDestinationEntries

        if (airports.length > 0 && !isObjectEmpty(this.state.otherDestinationEntries)) {
            newDestinationEntries = {
                ...this.state.otherDestinationEntries,
                airport: [...airports]
            }
        } else if (airports.length > 0) {
            newDestinationEntries = {
                airport: [...airports]
            }
        } else {
            newDestinationEntries = {
                ...this.state.otherDestinationEntries
            }
        }

        this.props.onPut({ hotelCode: this.state.hotelCode, formData: newDestinationEntries })

        this.setState({
            pendingAirports: [...airports],
            newPendingAirport: undefined,
            isLoading: true,
            loadingMessage: FormConst.MODAL_UPDATE_ACTION_TEXT,
            showDeleteModal: false
        })
    }

    addAirport = async () => {
        const country = this.state.countryCode
        this.getStatesForCountry(country)
        this.setState({
            isEdit: false, editIndex: -1, showNewAirportFields: true,
            initialValues: {
                ...this.state.initialValues,
                country: country,
                stateOptions: [],
                airportOptions: []
            }
        })
    }

    componentDidUpdate(prevProps) {
        if (prevProps.count !== this.props.count) {
            if (this.props.errorMessage) {
                this.setState({
                    isLoading: false,
                    showErrorModal: true,
                    errorMessage: this.props.errorDescription,
                    pendingAirports: undefined,
                    newPendingAirport: undefined,
                    initialValues: {
                        ...this.initialValues,
                        ...this.state.newPendingAirport
                    }
                })
            } else {

                if (this.props.httpAction === actionTypes.ASYNC_ACTIONS.GET_STATES) {
                    const country = this.props.destinationsResponse.countries[0]
                    const states = country.subdivisions

                    const stateOptions = states.map(state => {
                        return {
                            label: state.name,
                            value: state.isoCode.split('-')[1],
                            commonAbbreviation: state.commonAbbreviation
                        }
                    })

                    if (!isArrayNotEmpty(stateOptions)) {
                        const queryParams = { countryCode: country.iso2Code }
                        this.props.onGetAirports({ hotelCode: this.state.hotelCode, queryParams: queryParams })
                    }

                    this.setState({
                        isLoading: false,
                        initialValues: {
                            ...this.state.initialValues,
                            country: country.iso2Code,
                            state: '',
                            airportCode: '',
                            airportName: '',
                            stateOptions: sortObjectList(stateOptions, 'label')
                        }
                    })
                } else if (this.props.httpAction === actionTypes.ASYNC_ACTIONS.GET_AIRPORTS) {
                    const iataLocations = this.props.destinationsResponse.iataLocation
                    const airportIataLocations = searchObjectList('iataLocationKind', 'AIRPORT', iataLocations)

                    const airportOptions = airportIataLocations.map(airport => {
                        return {
                            label: airport.iataLocationCode + ' (' + airport.city + ')',
                            value: airport.iataLocationCode,
                            state: airport.stateOrProvince,
                            name: airport.city
                        }
                    })

                    this.setState({
                        isLoading: false,
                        initialValues: {
                            ...this.state.initialValues,
                            airportOptions: airportOptions
                        }
                    })
                } else {
                    // Scroll the table into view after saving
                    scrollToHtmlElementById('airports-table')
                    this.setState({
                        isLoading: false, airports: this.state.pendingAirports,
                        initialValues: { ...this.initialValues }, showNewAirportFields: false,
                        isEdit: false, editIndex: -1, deleteIndex: -1, showDeleteModal: false
                    })
                }
            }
        }
    }

    getStatesForCountry = (country) => {
        this.props.onGetStates({ hotelCode: this.state.hotelCode, locationType: "airport", queryParams: { countryCode: country, expand: 'subdivisions' } })
        this.setState({ initialValues: { ...this.state.initialValues, country: country, state: '', stateOptions: [], airportOptions: [] } })
    }

    getAirportCodes = (country, state) => {
        if (!country) {
            this.setState({
                airportCodesError: 'Country is required to get airport codes'
            })
            return
        } else {
            const queryParams = { countryCode: country }
            if (state && state !== FormConst.VALUE_ALL_STATES) {
                queryParams.stateCode = state
                const stateOption = searchFirstObjectInList('value', state, this.state.initialValues.stateOptions)
                if (stateOption?.commonAbbreviation) {
                    queryParams.commonAbbreviation = stateOption.commonAbbreviation
                }
            }
            this.props.onGetAirports({ hotelCode: this.state.hotelCode, queryParams: queryParams })
            this.setState({
                initialValues: {
                    ...this.state.initialValues,
                    country: country,
                    state: state,
                    airportOptions: []
                }
            })
        }
    }

    render() {
        let formTable = <table id='airports-table' className='table table-striped airports-table'>
            <thead>
                <tr>
                    <th>Country</th>
                    <th className='d-none d-lg-table-cell'>State</th>
                    <th>Airport Code</th>
                    <th className='d-none d-lg-table-cell'>Airport Name</th>
                    <th>Edit</th>
                    <th>Delete</th>
                </tr>
            </thead>
            <tbody>
                {
                    isArrayNotEmpty(this.state.airports)
                        ? this.state.airports.map((airport, index) => {
                            return <tr key={index}>
                                <td>{airport.address?.country}</td>
                                <td className='d-none d-lg-table-cell'>{airport.address?.state}</td>
                                <td>{airport.code}</td>
                                <td className='d-none d-lg-table-cell'>{airport.name}</td>
                                <td><Button name={<FaEdit />} role='link' className={this.state.showNewAirportFields ? 'icon-link-disabled' : 'icon-link'} onClick={() => this.onEdit(index)} overridedisabledflag='true' /></td>
                                <td><Button name={<FaTrashAlt />} role='link' className={this.state.showNewAirportFields ? 'icon-link-disabled' : 'icon-link'} onClick={() => this.handleDelete(index)} /></td>
                            </tr>
                        })
                        : <tr>
                            <td colSpan={6}>There are no entries for airports</td>
                        </tr>
                }
            </tbody>
        </table>

        return (
            <Formik
                initialValues={this.state.initialValues}
                validationSchema={this.validationSchema}
                enableReinitialize={true}
                onSubmit={(data, { setSubmitting, resetForm }) => {
                    setSubmitting(true)
                    this.handleSubmit(data)
                    setSubmitting(false)
                    resetForm()
                }}>
                {
                    ({ values, errors, touched, dirty, isSubmitting, isValid, resetForm, handleChange }) => (
                        <Form className='airports-form'>
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item"><NavLink to={RouteConst.ROUTE_HOME_PAGE}>Home</NavLink></li>
                                    <li className="breadcrumb-item"><NavLink to={RouteConst.ROUTE_DESTINATIONS_PAGE}>Destinations</NavLink></li>
                                    <li className="breadcrumb-item active" aria-current="page">Airports</li>
                                </ol>
                            </nav>
                            <p className='hotel-destinations-type'>Airports</p>
                            <p className='helper-text'>{FormConst.AIRPORTS_HELPER_TEXT}</p>

                            {formTable}

                            {
                                this.state.airports.length < FormConst.DESTINATIONS_CATEGORY_TRANSPORTATION_MAX_COUNT
                                && <div className='new-airports-fields-toggle'>
                                    <Button
                                        id='add-airport-button'
                                        name='Add Airport'
                                        role='primary'
                                        disabled={this.state.showNewAirportFields}
                                        onClick={this.addAirport} />
                                </div>
                            }

                            {/* Show new airport fields only when add button is clicked */}
                            {
                                this.state.showNewAirportFields &&
                                <div id='new-airport-collapse-fields'>
                                    <div className='new-airport-form-fields'>
                                        <SelectInput
                                            name='country'
                                            type='text'
                                            label='Country'
                                            onInput={(e) => this.getStatesForCountry(e.target.value)}
                                            options={this.state.countryOptions}
                                            isrequired='true' />
                                        {
                                            isArrayNotEmpty(values.stateOptions) && (
                                                <SelectInput
                                                    name='state'
                                                    type='text'
                                                    label='State or Province'
                                                    onInput={(e) => this.getAirportCodes(values.country, e.target.value)}
                                                    options={[{ label: FormConst.LABEL_ALL_STATES, value: FormConst.VALUE_ALL_STATES }, ...values.stateOptions]}
                                                    isrequired='true' />
                                            )
                                        }
                                        {
                                            !values.airportOptions && (
                                                <Button
                                                    role='link'
                                                    name='Discard'
                                                    className='cancel-new-airport'
                                                    onClick={() => this.discardNewFields(resetForm)} />
                                            )
                                        }
                                        {
                                            this.state.airportCodesError
                                            && <p className='error load-airports-error'>{this.state.airportCodesError}</p>
                                        }
                                        {
                                            values.airportOptions && (
                                                <>
                                                    <SelectInput
                                                        name='airportCode'
                                                        label='Airport Code'
                                                        isrequired='true'
                                                        onInput={(e) => { values.airportName = searchObjectList('value', e.target.value, values.airportOptions)[0].name }}
                                                        options={values.airportOptions} />
                                                    <TextInput
                                                        name='distance'
                                                        type='number'
                                                        label='Distance'
                                                        suffix={this.state.distanceUnits}
                                                        min={0} max={FormConst.MAX_DESTINATION_DISTANCE} step='0.5'
                                                        isrequired='true' />
                                                    <SelectInput
                                                        name='direction'
                                                        label='Direction'
                                                        options={FormConst.DIRECTION_OPTIONS}
                                                        isrequired='true' />
                                                    <ToggleSwitch
                                                        id='is-shuttle'
                                                        name='isShuttle'
                                                        checked={values.isShuttle}
                                                        label='Is Shuttle available?'
                                                        options={FormConst.SWITCH_OPTIONS_YES_NO}
                                                        onChange={handleChange} />
                                                    {
                                                        values.isShuttle
                                                        && (
                                                            <>
                                                                <ToggleSwitch
                                                                    id='is-shuttle-free'
                                                                    name='isShuttleFree'
                                                                    checked={values.isShuttleFree}
                                                                    label='Is Shuttle free?'
                                                                    options={FormConst.SWITCH_OPTIONS_YES_NO}
                                                                    onChange={handleChange}
                                                                    isrequired='true' />
                                                                <TextInput name='startTime' type='time' label='Start Time' isrequired='true' />
                                                                <TextInput name='endTime' type='time' label='End Time' isrequired='true' />
                                                            </>
                                                        )
                                                    }
                                                </>
                                            )
                                        }
                                        {
                                            values.airportOptions
                                            && <Row className='new-fields-footer-row'>
                                                <Col xs={1} sm={1} md={4} lg={4} xl={4}></Col>
                                                <Col xs={3} sm={4} md={2} lg={1} xl={1}><Button role='link' type="submit" name={FormConst.SAVE_LINK_TEXT} formNoValidate /></Col>
                                                <Col xs={4} sm={4} md={2} lg={1} xl={1}><Button role='link' name={FormConst.DISCARD_LINK_TEXT} onClick={() => {
                                                    if (dirty) {
                                                        this.handleClearForm()
                                                    } else {
                                                        this.discardNewFields(resetForm)
                                                    }
                                                }
                                                }
                                                    overridedisabledflag='true' />
                                                </Col>
                                                <Col xs={1} sm={1} md={4} lg={6} xl={6}></Col>
                                            </Row>
                                        }
                                    </div>
                                </div>
                            }

                            {
                                this.state.showNewAirportFields
                                && <p className='error text-center'>Please save or discard your changes to proceed</p>
                            }

                            <FormFooter
                                form={{
                                    previous: { title: this.state.returnTitle, route: this.state.returnDirection },
                                    next: { title: 'Long Distance Transportation', route: RouteConst.ROUTE_LONG_DISTANCE_TRANSPORTATION_PAGE }
                                }}
                                submitName={this.state.continueFlow ? 'Proceed to Restaurants' : 'Go back to Destinations'}
                                onSubmit={this.handleProceed}
                                submitDisabled={this.state.showNewAirportFields}
                                noReset />
                            <FormModal
                                id='airports-page-save-modal'
                                title={FormConst.MODAL_UPDATE_ACTION_TITLE}
                                hotelInfo={this.state.hotelInfo}
                                body={<h5>{this.state.loadingMessage}</h5>}
                                show={this.state.isLoading}
                                isLoadingIndicator />
                            <FormModal
                                id='airports-page-discard-modal'
                                hotelInfo={this.state.hotelInfo}
                                title={FormConst.MODAL_DISCARD_ACTION_TITLE}
                                body={<h5>{FormConst.MODAL_DISCARD_ACTION_TEXT}</h5>}
                                proceed={() => {
                                    this.discardNewFields(resetForm)
                                }}
                                cancel={() => { this.setState({ showResetModal: false }) }}
                                show={this.state.showResetModal} />
                            <FormModal
                                id='airports-page-delete-modal'
                                hotelInfo={this.state.hotelInfo}
                                title={'Delete Airport'}
                                body={<h5>{FormConst.MODAL_DELETE_ACTION_TEXT}</h5>}
                                proceed={this.onDelete}
                                cancel={() => { this.setState({ showDeleteModal: false }) }}
                                show={this.state.showDeleteModal} />
                            <FormModal
                                id='airports-page-error-modal'
                                hotelInfo={this.state.hotelInfo}
                                title={FormConst.MODAL_UPDATE_ACTION_ERROR_TITLE}
                                body={<h5>{this.state.errorMessage}</h5>}
                                isError
                                cancel={() => { this.setState({ showErrorModal: false }) }}
                                show={this.state.showErrorModal} />
                        </Form>
                    )
                }
            </Formik>
        )
    }
}

// Sample redux dispatch
const mapStateToProps = state => {
    return {
        destinationsResponse: state.reducer.response,
        errorMessage: state.reducer.errorMessage,
        errorDescription: state.reducer.errorDescription,
        count: state.reducer.count,
        httpAction: state.reducer.httpAction
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onGet: (hotelCode) => dispatch(asyncMethod(FormConst.FORM_HOTEL_DESTINATIONS_NAME, actionTypes.ASYNC_ACTIONS.GET, { hotelCode: hotelCode })),
        onPut: (data) => dispatch(asyncMethod(FormConst.FORM_HOTEL_DESTINATIONS_NAME, actionTypes.ASYNC_ACTIONS.PUT, data)),
        onGetAirports: (data) => dispatch(asyncMethod(FormConst.FORM_HOTEL_DESTINATIONS_NAME, actionTypes.ASYNC_ACTIONS.GET_AIRPORTS, data)),
        onGetStates: (data) => dispatch(asyncMethod(FormConst.FORM_HOTEL_DESTINATIONS_NAME, actionTypes.ASYNC_ACTIONS.GET_STATES, data)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withFormLayout(Airports, SideNavEntryMapping.HOTEL_DESTINATIONS))